var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"w-stepper"},_vm._l((parseInt(_vm.stepCount)),function(n,index){return _c('li',{key:index,class:{active:n<=_vm.currentStep}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }